export const getPatientVisiblePractices = (appointment) =>
    (appointment?.nearest_practices || []).filter(
        (practice) => practice.practice_appointment_status === 'ACTIVE'
    );
